import vtkAppendPolyData from './AppendPolyData';
import vtkCalculator from './Calculator';
import vtkImageMarchingCubes from './ImageMarchingCubes';
import vtkImageMarchingSquares from './ImageMarchingSquares';
import vtkImageStreamline from './ImageStreamline';
import vtkMoleculeToRepresentation from './MoleculeToRepresentation';
import vtkOutlineFilter from './OutlineFilter';
import vtkPaintFilter from './PaintFilter';
import vtkTubeFilter from './TubeFilter';
import vtkWarpScalar from './WarpScalar';

export default {
  vtkAppendPolyData,
  vtkCalculator,
  vtkImageMarchingCubes,
  vtkImageMarchingSquares,
  vtkImageStreamline,
  vtkMoleculeToRepresentation,
  vtkOutlineFilter,
  vtkPaintFilter,
  vtkTubeFilter,
  vtkWarpScalar,
};
